import { cn } from '@commenda/utils';

import { type ChartColor, ChartColorHelper } from './chartColors';

export interface IChartLegendItem {
  name: string;
  color: ChartColor;
  shape?: 'bar' | 'line';
}

interface IChartLegendProps {
  items: IChartLegendItem[];
  className?: string;
}

export const ChartLegend = ({ items, className }: IChartLegendProps) => (
  <ol
    className={cn(
      'flex flex-wrap items-center justify-end gap-x-sm gap-y-xs',
      className
    )}
  >
    {items.map(({ name, color, shape = 'bar' }) => (
      <li
        key={name}
        className="inline-flex items-center gap-xs whitespace-nowrap px-sm py-xxs text-xs text-text-secondary"
      >
        <span
          aria-hidden="true"
          className={cn(
            'shrink-0 rounded-full',
            shape === 'line' ? 'h-[3px] w-3' : 'size-2',
            ChartColorHelper.className(color, 'bg')
          )}
        />
        <span className="truncate">{name}</span>
      </li>
    ))}
  </ol>
);
